var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error && _vm.error.length > 0
    ? _c("div", { class: "ui label basic red " + _vm.pointing }, [
        _vm.error.length === 1
          ? _c("span", [_vm._v(_vm._s(_vm.error[0]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.error.length > 1
          ? _c(
              "ul",
              _vm._l(_vm.error, function(err) {
                return _c("li", [_vm._v(_vm._s(err))])
              })
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db3abfee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db3abfee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/errorTag.vue
// module id = 531
// module chunks = 0